import CustomSwitchGraphicsList from './CustomSwitchGraphicsList'

export default CustomSwitchGraphicsList
